// extracted by mini-css-extract-plugin
export default {"blc":"blocker_blc__DavsL"};